import { PriceCandle } from '../types';
import { fetcher } from './fetcher';
import { BenchmarkHistoryRequestParams } from './types';
import { toCandle } from './utils';

export type GetHistoryParams = Pick<
  BenchmarkHistoryRequestParams,
  'from' | 'to' | 'resolution'
> & {
  ticker: string;
};

export const getHistory = async ({
  from,
  to,
  resolution,
  ticker,
}: GetHistoryParams): Promise<PriceCandle[]> => {
  const response = await fetcher({
    from,
    resolution,
    symbol: ticker,
    to,
  });
  if (response.s === 'error') return [];

  return toCandle(response);
};
